import { Card, Col, Row, Space, Switch, Tag, Typography } from "antd";
import {
  BellOutlined,
  CloudSyncOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Text } = Typography;

const settings = [
  {
    title: "Workspace context",
    description: "Keep the selected workspace in the URL and local session.",
    icon: <CloudSyncOutlined />,
    enabled: true,
  },
  {
    title: "Project notifications",
    description: "Show reminders for project and task activity.",
    icon: <BellOutlined />,
    enabled: true,
  },
  {
    title: "Secure requests",
    description: "Send Ovacus client headers with service requests.",
    icon: <SafetyCertificateOutlined />,
    enabled: true,
  },
];

const Settings = () => (
  <div className="project-page">
    <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3 flex-wrap">
      <WidgetSectionTitle
        icon={<SettingOutlined />}
        title="Settings"
        subtitle="Configure how Ovacus behaves for your workspace"
        className="flex-1"
        titleStyle={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}
        subtitleStyle={{ color: OLIVEEB_COLORS.oliveebGreen }}
      />
    </div>

    <Row gutter={[16, 16]}>
      {settings.map((item) => (
        <Col xs={24} lg={8} key={item.title}>
          <Card
            style={{
              height: "100%",
              borderRadius: 8,
              borderColor: OLIVEEB_COLORS.oliveebBlueSoft,
            }}
          >
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              <Space style={{ justifyContent: "space-between", width: "100%" }}>
                <span
                  style={{
                    display: "inline-grid",
                    placeItems: "center",
                    width: 38,
                    height: 38,
                    borderRadius: 8,
                    background: OLIVEEB_COLORS.oliveebBlueSoft,
                    color: OLIVEEB_COLORS.oliveebBlue,
                  }}
                >
                  {item.icon}
                </span>
                <Switch checked={item.enabled} disabled />
              </Space>
              <div>
                <Text strong style={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}>
                  {item.title}
                </Text>
                <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
                  {item.description}
                </Text>
              </div>
              <Tag color="green" style={{ width: "fit-content" }}>
                Enabled
              </Tag>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>
  </div>
);

export default Settings;
